import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=4ec7b1f6&scoped=true&"
var script = {}
import style0 from "./Logos.vue?vue&type=style&index=0&id=4ec7b1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec7b1f6",
  null
  
)

export default component.exports